import React, { useState } from 'react';
import { isBlank } from 'utils/helperMethods';
import useApp from 'reducers/hooks/useApp';
import { useTranslation } from 'react-i18next';

import useScreen from 'hooks/useScreen';
import { Box, Tabs, Tab, Button } from '@material-ui/core';
import AffordabilityCalculator from 'sharedComponents/AffordabilityCalculator';
import MothlyPaymentCalculator from 'sharedComponents/MothlyPaymentCalculator';
import Seo from 'sharedComponents/Seo';

import RightBar from './components/RightBar';
import useStyles from './useStyles';

const Calculators = () => {
  const classes = useStyles();
  const { isDesktop } = useScreen();
  const { t } = useTranslation();
  const { currentUser } = useApp();
  const isSignedIn = !isBlank(currentUser);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setActiveTabIndex(newValue);
  };

  const showAffordabilityCalculator = activeTabIndex === 0;
  const showMothlyPaymentCalculator = activeTabIndex === 1;

  return (
    <Box className={classes.container}>
      <Seo title={t('meta.Calculators.title')} description={t('meta.Calculators.description')} />
      <Box className={classes.paper}>
        {isDesktop && (
          <Box className={classes.rightBar}>
            <RightBar isSignedIn={isSignedIn} />
          </Box>
        )}
        <Box className={classes.content}>
          <Tabs
            value={activeTabIndex}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            className={classes.tabs}
          >
            <Tab label={t('components.Calculators.affordability')} value={0} className={classes.tab} />
            <Tab label={t('components.Calculators.monthlyPayment')} value={1} className={classes.tab} />
          </Tabs>
          <Box className={classes.calculator}>
            {showAffordabilityCalculator && <AffordabilityCalculator />}
            {showMothlyPaymentCalculator && <MothlyPaymentCalculator />}
          </Box>
        </Box>
      </Box>
      {!isSignedIn && (
        <Box className={classes.buttonContainer}>
          <Button
            className={classes.button}
            href="https://bundleloan.com/blog/compare-current-mortgage-rates/"
            target="_blank"
          >
            {t('components.Calculators.compareRates')}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default Calculators;



// WEBPACK FOOTER //
// ./src/components/Calculators/Calculators.js